import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combine des classes CSS de manière optimisée avec clsx et tailwind-merge
 * @param inputs - Classes CSS à combiner
 * @returns Chaîne de classes CSS optimisée
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

